import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchDashboardStats } from '../../lib/api';

export function useDashboardStats(constituencyId, campaignId, majorityThreshold = 20) {
  return useQuery({
    queryKey: queryKeys.dashboardStats(constituencyId, campaignId, majorityThreshold),
    queryFn: () => fetchDashboardStats(constituencyId, campaignId, majorityThreshold),
    enabled: !!(constituencyId && campaignId),
  });
}
